import {AlertTriangle} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const WarningIcon = createLucideIcon(AlertTriangle, 'WarningIcon');
